import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';
import DataState from '../../components/DataState';
import Lightbox from '../../components/Lightbox';
import VideoEmbed from '../../components/VideoEmbed';
import { useCollections } from '../../lib/api/collections';
import { useSeo } from '../../lib/seo';
import { publicFileUrl } from '../../lib/supabase';

const AlbumMain = () => {
  const { slug } = useParams();
  const content = useCollections('gallery');
  const album = content.gallery && content.gallery.find((a) => a.id === slug);
  useSeo(album ? { title: `${album.title} | Gallery | SANASA Campus`, description: album.description } : null);

  if (content.loading || content.error) return <DataState state={content} />;
  if (!album) return <Navigate to="/gallery" replace />;

  const photos = album.items.filter((i) => i.kind === 'image' && i.path).map((i) => ({ id: i.id, src: publicFileUrl('media', i.path), caption: i.caption }));
  const videos = album.items.filter((i) => i.kind === 'video' && i.videoUrl);

  return (
    <main>
      <Breadcrumb title={album.title} subTitle="Gallery" />
      <div className="sc-listing pt-120 pb-90">
        <div className="container">
          <p className="mb-30"><Link to="/gallery">&larr; All albums</Link></p>
          {album.description && <p className="sc-album-intro mb-40">{album.description}</p>}
          {photos.length === 0 && videos.length === 0 && (
            <div className="sc-empty-state"><h4>This album is empty for now</h4><p>Photos and videos will be added soon.</p></div>
          )}
          {photos.length > 0 && <Lightbox images={photos} />}
          {videos.length > 0 && (
            <div className="row mt-40">
              {videos.map((v) => (
                <div key={v.id} className="col-xl-6 col-lg-6 mb-30">
                  <VideoEmbed url={v.videoUrl} title={v.caption || album.title} />
                  {v.caption && <p className="mt-10">{v.caption}</p>}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default AlbumMain;
